var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlyphiconsLoading({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M10.915 5.954V0H12.9v5.954h-1.984zm0 17.861v-5.953H12.9v5.953h-1.984zM0 12.9v-1.985h5.954V12.9H0zm17.862 0v-1.985h5.952V12.9h-5.952zM2.785 4.189l1.403-1.403 4.21 4.21L6.995 8.4l-4.21-4.21zM15.412 16.82l1.403-1.404 4.21 4.21-1.403 1.403-4.21-4.209zM4.18 21.029l-1.404-1.404 4.21-4.21L8.39 16.82l-4.209 4.21zM16.821 8.402L15.418 7l4.21-4.209 1.403 1.402-4.21 4.21z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#4D4D4D",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .5h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlyphiconsLoading);
export default __webpack_public_path__ + "static/media/glyphicons-loading.523bb2bd.svg";
export { ForwardRef as ReactComponent };